import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Zoom,
} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import React, { useMemo, useState } from "react";
import { usePagination, useTable } from "react-table";
import {
  formatDate,
  formatDocument,
} from "../../../../../../../../utils/formatters";
import { default as CustomButton } from "../../../../../../../ui/button";
import Tag from "../../../../../../../ui/tag";
import DividasAtivasModal from "./dividas-ativas-modal";

const PER_PAGE = 10;

const baseColumns = [
  {
    accessor: (row) => row.pessoa?.nome || row.nome,
    style: { textAlign: "center" },
    Header: "Nome",
  },
  {
    accessor: (row) => row.pessoa?.cpfCnpj || row.documento,
    style: { textAlign: "center" },
    Header: "Documento",
    Cell: ({ value }) => formatDocument(value),
  },
];

const buttonColumn = {
  style: { textAlign: "center" },
  Header: "",
  toggable: false,
  disableSortBy: true,
};

const showValue = (value) => value || "-";

const ViewDetailsButton = (props) => (
  <Tooltip
    title={<span style={{ fontSize: "11px" }}>Ver detalhes</span>}
    TransitionComponent={Zoom}
    arrow
  >
    <CustomButton size="small" {...props}>
      <InfoOutlinedIcon />
    </CustomButton>
  </Tooltip>
);

const PessoasTable = ({ type, data, onViewDetails }) => {
  const [dividasAtivas, setDividasAtivas] = useState();

  const columns = useMemo(
    () =>
      type === "homônimos"
        ? [
            ...baseColumns,
            {
              accessor: "cidade",
              style: { textAlign: "center" },
              Header: "Cidade",
              Cell: ({ value }) => showValue(value),
            },
            {
              accessor: "uf",
              style: { textAlign: "center" },
              Header: "UF",
              Cell: ({ value }) => showValue(value?.toUpperCase()),
            },
            {
              ...buttonColumn,
              accessor: "documento",
              Cell: ({ value }) => (
                <ViewDetailsButton onClick={() => onViewDetails(value)} />
              ),
            },
          ]
        : [
            ...baseColumns,
            {
              accessor: "pessoa.dataNascimento",
              style: { textAlign: "center" },
              Header: "Data de Nascimento",
              Cell: ({ value }) => formatDate(value),
            },
            {
              ...buttonColumn,
              accessor: "dividaAtivas",
              Cell: ({ value }) => {
                return (
                  value?.length > 0 && (
                    <Tag
                      text="divida"
                      onClick={() => setDividasAtivas(value)}
                    />
                  )
                );
              },
            },
            {
              ...buttonColumn,
              accessor: "id",
              Cell: ({ row, value }) => (
                <ViewDetailsButton
                  id={`view_credor_details_${value}`}
                  onClick={() => onViewDetails(row.original)}
                />
              ),
            },
          ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    gotoPage,
    state: { pageIndex },
  } = useTable(
    {
      data,
      columns,
    },
    usePagination
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <TableContainer>
          <Table
            {...getTableProps()}
            className={`${type}-table`}
            aria-label={type}
          >
            <caption>{`Tabela de ${type}`}</caption>

            <TableHead>
              {headerGroups.map((headerGroup) => (
                <TableRow {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <TableCell {...column.getHeaderProps()}>
                      {column.render("Header")}

                      <span>
                        {data.length > 0 && column.isSorted && (
                          <i
                            className={`fas fa-sort-${
                              column.isSortedDesc ? "down" : "up"
                            }`}
                          ></i>
                        )}
                      </span>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableHead>

            <TableBody {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row);

                const { cells, getRowProps } = row;

                return (
                  <React.Fragment key={i}>
                    <TableRow {...getRowProps()}>
                      {cells.map(({ getCellProps, render }) => (
                        <TableCell key={i} {...getCellProps()}>
                          {render("Cell")}
                        </TableCell>
                      ))}
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>

            <TableFooter>
              {data.length == 0 ? (
                <TableRow>
                  <TableCell>{`Sem dados de ${type}`}</TableCell>
                </TableRow>
              ) : (
                data.length > PER_PAGE && (
                  <TableRow>
                    <TablePagination
                      count={data.length}
                      rowsPerPage={PER_PAGE}
                      page={pageIndex}
                      onChangePage={(_, number) => gotoPage(number)}
                    />
                  </TableRow>
                )
              )}
            </TableFooter>
          </Table>
        </TableContainer>
      </Grid>

      <DividasAtivasModal
        data={dividasAtivas}
        onClose={() => setDividasAtivas(null)}
      />
    </Grid>
  );
};

export default PessoasTable;
